import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import slugify from 'react-slugify'

import StoreGroup from './StoreGroup'
import StorePage from './StorePage'

const capitalize = require('capitalize')

const StoreVoucher = ({ stores }) => {
  const removeVouchersIds = [61719, 61718, 21217, 61751]
  const addVirtual = [21098, 21110, 21114, 21119, 21128, 21133, 41418, 51473, 51482, 21099, 21112, 21116, 21120, 21131, 21136, 41420, 51474, 61912, 21109, 21113, 21118, 21122, 21132, 21281, 51472, 51481]
  const addPhysical = [21210]

  var virtualVouchers = []
  var physicalVouchers = []

  if (stores.vouchers && stores.vouchers.length) {
    stores.vouchers.map((store) => {
      var storeNameSlug = slugify(store.name, { delimiter: '-' })

      if (!removeVouchersIds.includes(store.supplierId)) {
        if (storeNameSlug.includes('virtual') || addVirtual.includes(store.supplierId)) {
          virtualVouchers.push({ ...store, name: sanitizeString(store.name, 'virtual') })
        } else if (storeNameSlug.includes('fisico') || addPhysical.includes(store.supplierId)) {
          physicalVouchers.push({ ...store, name: sanitizeString(store.name, 'fisico') })
        }
      }
    })

    virtualVouchers = virtualVouchers.sort(sortString)
    physicalVouchers = physicalVouchers.sort(sortString)
  }

  return (
    <Fragment>
      <Helmet>
        <title>{`Todos os cupons e serviços - ${process.env.REACT_APP_TITLE || ''}`}</title>
      </Helmet>
      <StorePage>
        <div className='row'>
          <StoreGroup
            items={physicalVouchers}
            title='Vouchers Físicos'
            hasContent={physicalVouchers.length > 0}
          />
        </div>
      </StorePage>
      <StorePage>
        <div className='row'>
          <StoreGroup
            items={virtualVouchers}
            title='Vouchers Virtuais'
            hasContent={virtualVouchers.length > 0}
          />
        </div>
      </StorePage>
    </Fragment>
  )
}

StoreVoucher.propTypes = {
  stores: PropTypes.object.isRequired
}

const sortString = (a, b) => {
  var aName = slugify(a.name, { delimiter: '-' })
  var bName = slugify(b.name, { delimiter: '-' })

  if (aName > bName) {
    return 1
  } else if (bName > aName) {
    return -1
  }
  return 0
}

const sanitizeString = (string, type) => {
  var str = string.toLowerCase().replace(type, '')

  if (type === 'fisico') {
    str = str.replace('físico', '')
  }

  str = str.trim().replace(' -', '').replace('-', '').replace('.', '').replace('dshop', '')
  return capitalize.words(str)
}

const mapStateToProps = ({ stores }) => ({
  stores
})

export default connect(
  mapStateToProps,
  null
)(StoreVoucher)



// WEBPACK FOOTER //
// ./src/features/Store/StoreVoucher.js